module.exports = __webpack_public_path__ + "img/group.90f9b7f2.svg";